<template>
  <base-floating-card @close="close">
    <date-picker :chosenDate="initialValue" @dateChosen="input" />
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";

import DatePicker from "../../../Elements/DatePicker.vue";
export default {
  data() {
    return {
      value: undefined,
    };
  },
  methods: {
    input(val) {
      this.value = val;
      this.close();
    },
    close() {
      this.$emit("close", this.value);
    },
  },
  components: {
    BaseFloatingCard,
    DatePicker,
  },
  props: ["initialValue"],
  emits: ["close"],
};
</script>
<style scoped></style>
